import React from 'react';
import { CompassIcon } from 'lucide-react';
const stats = [{
  emoji: '📄',
  value: '6',
  label: 'volumi'
}, {
  emoji: '🗂',
  value: '23',
  label: 'schede WS'
}, {
  emoji: '🧭',
  value: '10 sedute',
  label: 'in 3 fasi'
}, {
  emoji: '🧰',
  value: 'Documenti',
  label: 'professionali pronti da usare'
}];
const coverage = ['Diagnosi e onboarding', 'Credenze limitanti', 'Passaggio all’azione', 'Cliente bloccato', 'Chiusura del percorso', 'Pratica professionale'];
export function ProductReveal() {
  return <section aria-labelledby="reveal-heading" className="w-full bg-white" data-id="element-193" data-mp="28fm486tog476">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-194" data-mp="2n3p8nbs2n7tv">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-soft text-terracotta border border-terracotta/20 text-[11px] sm:text-xs font-bold uppercase tracking-[0.12em]" data-id="element-195" data-mp="2icquahqn8jt9">
          <CompassIcon className="w-4 h-4" aria-hidden="true" data-id="element-196" data-mp="1po1s0fduq8fx" />
          Il sistema operativo completo per chi fa coaching in Italia
        </div>

        <h2 id="reveal-heading" className="mt-7 font-serif font-black text-ink text-[30px] sm:text-5xl leading-[1.1] tracking-tight" data-id="element-197" data-mp="1b0frdzh41l0b">
          Il Sistema Completo del Coach™
        </h2>

        <p className="mt-4 font-serif text-lg sm:text-2xl text-sage leading-snug max-w-2xl mx-auto" data-id="element-198" data-mp="1jvc95gewc5zs">
          6 volumi + 5 bonus — Dal colloquio esplorativo alla seduta di
          chiusura, con il Metodo BUSSOLA™: Diagnosi, Direzione, Deliverable.
        </p>

        <p className="mt-6 text-ink-soft text-base leading-relaxed max-w-2xl mx-auto" data-id="element-199" data-mp="w4gbw3ro8il5">
          Non è un corso. Non è un&apos;altra certificazione. Non è una raccolta
          di tecniche. È la pratica professionale completa, messa per iscritto.{' '}
          <strong className="text-ink font-semibold" data-id="element-200" data-mp="2chx1aj374m4e">
            23 schede di lavoro, script e documenti che si usano durante la
            seduta
          </strong>{' '}
          — non la sera prima.
        </p>

        <ul className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-201" data-mp="1rscmrn84vtg4">
          {stats.map(stat => <li key={stat.label} className="rounded-2xl bg-cream border border-cream-dark p-4 sm:p-5" data-id="element-202" data-mp="1muknu992n72f">
              <span className="text-xl" aria-hidden="true" data-id="element-203" data-mp="21oz627ktacg1">
                {stat.emoji}
              </span>
              <p className="mt-1 font-serif font-bold text-xl sm:text-2xl text-ink" data-id="element-204" data-mp="1wq4fukkilllw">
                {stat.value}
              </p>
              <p className="text-xs sm:text-sm text-ink-muted leading-snug" data-id="element-205" data-mp="143tcj25ix6le">
                {stat.label}
              </p>
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-206" data-mp="1iu0px3gobzf8">
          <p className="text-xs uppercase tracking-[0.16em] text-ink-muted font-semibold" data-id="element-207" data-mp="1e0xroi0yc1sp">
            Copertura completa
          </p>
          <ul className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-208" data-mp="qabxnuns8i1p">
            {coverage.map(chip => <li key={chip} className="rounded-full bg-sage-tint text-sage border border-sage-soft px-3.5 py-1.5 text-xs sm:text-sm font-semibold" data-id="element-209" data-mp="lcjug4hot9i7">
                {chip}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}